import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MultiDocEditDialogModel } from '@dialogs/multi-doc-edit-dialog/multi-doc-edit-dialog.model';
import { DocCodingResponsiveness } from '@enums/doc-coding-responsiveness.enum';
import { BuiltInFieldId } from '@models/built-in-field-id.enum';
import { FieldType } from '@models/field/field-type.enum';
import { MultiDocGroup } from '@models/field/multi-doc-field.model';
import { FolderResource } from '@models/resource/folder.resource';
import { MultiDocPostBody } from '@models/review/multi-doc-post-body';
import { MultiDocFieldService } from '@services/multi-doc-field.service';
import { KeyHandlerDirective } from 'src/app/directives/key-handler.directive';

@Component({
    selector: 'lex-multi-doc-edit',
    templateUrl: './multi-doc-edit.component.html',
    styleUrls: ['./multi-doc-edit.component.scss'],
    standalone: false
})
export class MultiDocEditComponent extends KeyHandlerDirective {

  public readonly expandEmailFamilySelected;
  public model: MultiDocPostBody;
  public multiDocGroups: MultiDocGroup[] = [];
  public isDocViewer = false;
  public okText: string;
  public controlType: string;
  public checkboxText: string;
  public dropDownData: Array<any> = [];

  get checkboxState(): boolean {
		if (!this.model.newFieldValue) this.model.newFieldValue = false.toString();
		return Boolean(JSON.parse(this.model.newFieldValue));
	}
	set checkboxState(value: boolean) {
		this.model.newFieldValue = value.toString();
	}

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MultiDocEditDialogModel,
    private dialogRef: MatDialogRef<MultiDocEditComponent>,
    private multiDocFieldService: MultiDocFieldService
  ) {
    super();
    this.expandEmailFamilySelected = data.expandEmailFamilySelected;
    this.multiDocGroups = data.multiDocGroups;
    const docCount = data.totalDocsSelected;

    this.model = {
      expandEmailFamily: this.expandEmailFamilySelected,
      setReviewByMe: false,
      isEdit: true,
      targetFieldId: data.dialogInfo.fieldId,
      targetFieldType: data.dialogInfo.fieldType,
      targetDisplayTitle: data.dialogInfo.dialogTitle
    };

    if (data.isDocViewer)
      this.isDocViewer = true;

    if (this.isDocViewer)
      this.okText = 'Select';
    else if (docCount === 1)
      this.okText = 'Update 1 Doc';
    else
      this.okText = `Update ${docCount} Docs`;

    const targetType = this.model.targetFieldType;
    for (let i = 0; i < this.multiDocGroups.length; i++) {
      for (let j = 0; j < this.multiDocGroups[i].fields.length; j++) {
        const field = this.multiDocGroups[i].fields[j];
        field.disabled = false;
        if (targetType === FieldType.BuiltInFieldText || targetType === FieldType.TextField) {
          if (field.fieldType !== FieldType.BuiltInFieldText && field.fieldType !== FieldType.TextField)
            field.disabled = true;
        }
        else if (targetType === FieldType.CheckBox || targetType === FieldType.SharedCheckBox || targetType === FieldType.BuiltInFieldCheckBox) {
          if (field.fieldType !== FieldType.CheckBox && field.fieldType !== FieldType.SharedCheckBox && field.fieldType !== FieldType.BuiltInFieldCheckBox)
            field.disabled = true;
        } else
          field.disabled = true;
      }
    }

    switch (this.model.targetFieldId) {
      case BuiltInFieldId.Responsive:
      case BuiltInFieldId.Confidential:
      case BuiltInFieldId.CustomDesignation:
      case BuiltInFieldId.Privilege:
      case BuiltInFieldId.WorkProduct:
        this.model.setReviewByMe = true;
        break;
      default:
        this.model.setReviewByMe = false;
        break;
    }

    switch (this.model.targetFieldType) {
      case FieldType.BuiltInFieldDate:
        this.controlType = 'date';
        break;
      case FieldType.BuiltInFieldUniqueIdentifier:
        if (this.model.targetFieldId === BuiltInFieldId.Custodian) {
          this.controlType = 'select';
          this.multiDocFieldService.getCustodianListForMultiDocEdit()
            .subscribe(custodian => {
              this.dropDownData = custodian.map(value => {
                return { value: value.custodianId, displayTitle: value.name };
              });
            });
        } else {
          this.controlType = 'folder';
        }
        break;
      case FieldType.BuiltInFieldDropDownList:
        this.controlType = 'select';
        this.dropDownData = [
          { value: `${DocCodingResponsiveness.NotSpecified}`, displayTitle: '' },
          { value: `${DocCodingResponsiveness.Responsive}`, displayTitle: 'Responsive' },
          { value: `${DocCodingResponsiveness.NonResponsive}`, displayTitle: 'Non-Responsive' },
          { value: `${DocCodingResponsiveness.NeedsFurtherReview}`, displayTitle: 'Needs Further Review' },
        ];
        this.model.newFieldValue = this.dropDownData[0].value;
        break;
      case FieldType.BuiltInFieldInt32:
      case FieldType.BuiltInFieldCheckBox:
      case FieldType.CheckBox:
      case FieldType.SharedCheckBox:
        this.controlType = 'check';
        this.checkboxText = this.model.targetDisplayTitle;
        break;
      case FieldType.BuiltInFieldText:
      case FieldType.BuiltInFieldBates:
      case FieldType.TextField:
      default:
        this.controlType = 'text';
        this.model.newFieldValue = '';
        break;
    }
  }

  public ok(): void {
    this.dialogRef.close(this.model);
  }

  public folderSelect(path: FolderResource[]) {
		const folderId = path ? path[path.length - 1].folderId : null;
		this.model.newFieldValue = folderId;
	}

}
